import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "./ForgetPassword.css";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { USER_API_URL } from "../utlis/common";
const ForgetPassword = () => {
  // const [username, setusername] = useState();
  const [name, setname] = useState();
  const [password, setpassword] = useState();
  const [Arrayval, setArrayVal] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const values = localStorage.getItem('currentUser') === 'undefined' ? 'null' : JSON.parse(localStorage.getItem('currentUser'));

    // if (values === '' || values === null || values === undefined) {
    //     navigate("/");
    //     return;
    // }
    fetchuserNameList();
  }, [navigate]);

  const fetchuserNameList = async () => {
    try {
      const response = await axios.get(USER_API_URL);
      if(response.data.code === 200){
        setArrayVal(response.data.data);
      }
      else{
        setArrayVal([]);
      }
    } catch (error) {
      toast.error("Failed to fetch registrations!");
    }
  };
  const handleSave = async () => {

    if (!name || !password) {
      toast.error("Please fill all fields!", { position: "top-center" })
      return
    }
    if(password.length < 6){
      toast.error(" Password must be at leat 6 characters long.");
      return ;
    }

    const checkrecord = Arrayval.filter((record) => record && record.Name);

    const isTaken = checkrecord.some((record) =>
      record.Name.toLowerCase() === name.toLowerCase()
    );

    if (!isTaken) {
      toast.error('Name does not exists');
      return
    }


    const validRecords = Arrayval.filter((record) => record && record.Name === name);
    const cuurentvalue = validRecords && validRecords[0];

    const FormData = {
      sno: cuurentvalue.Sno,
      name: cuurentvalue.Name,
      userName: cuurentvalue.UserName,
      password: password,
      userRole: cuurentvalue.UserRole,
      status: 'Active'
    };
    const response = await axios.put(USER_API_URL, FormData, {
      headers: { "Content-Type": "application/json" },
    });
    if (response.data.code === 200) {
      toast.success(response.data.message);
      setname('');
      setpassword('');
      setTimeout(() => {
        navigate('/')
      }, 1000);

    }
    else {
      toast.error("Failed to submit the form!", { position: "top-center" });
    }
  }
  const closePopup = async () => {
    setname('');
    setpassword('');
  }
  const backPopup = async () => {
    navigate('/')
  }
  const handleInputChange = (event) => {
    const newUsername = event.target.value;
    setname(newUsername);

  };

  const checkUsernameAvailability = (newUsername) => {

    if (!newUsername) {
      return;
    }
    // If the username is empty, don't validate
    if (newUsername.trim() === '') {
      // setIsUsernameTaken(false);
      return;
    }

    const validRecords = Arrayval.filter((record) => record && record.Name);

    const isTaken = validRecords.some((record) =>
      record.Name === newUsername
    );

    if (!isTaken) {
      toast.error('Name does not exists');
    } else {
      // setIsUsernameTaken(false);
    }
  }
  const check_password = (value) => {
    if(value.length < 6){
          toast.error(" Password must be at leat 6 characters long.");
          return ;
        }
    const regex = /^[a-zA-Z0-9,&""./;:()+%^*=><}{''@#$!_-]*$/;

    if (!regex.test(value)) {
      toast.error("Enter a valid password!");
      return false;
    }
    return true;
  }
  return (

    <div className="popup-overlay_for">
      <ToastContainer
        autoClose={500} // Auto-close in 20 seconds
        toastStyle={{ backgroundColor: "white", color: 'black', fontFamily: "'Roboto', sans-serif" }}
        progressStyle={{ background: 'white' }} />
      <div className="popup-content">
        <h2>Change Password</h2>
        <div className="mrg_bottom1">
        <div className="ft_wt_mrg_btm">Name of the User<span className="asterisk">*</span></div>
          <input
            type="text"
            placeholder="Enter name"
            value={name}
            maxLength={50}
            onChange={(e) => handleInputChange(e)}
            onBlur={() => checkUsernameAvailability(name)}
          />
          {/* <div className="ft_wt_mrg_btm">User name<span className="asterisk">*</span></div>
          <input
            type="text"
            placeholder="Enter username"
            value={username}
            maxLength={50}
            onChange={(e) => handleInputChange(e)}
            onBlur={() => checkUsernameAvailability(username)}
          /> */}

          <div className="ft_wt_mrg_btm">New password<span className="asterisk">*</span></div>
          <input
            type="text"
            placeholder="Enter password"
            value={password}
            maxLength={50}
            onChange={(e) => setpassword(e.target.value.replace(/\s+/g, ""))}
            onBlur={() => check_password(password)}
          />
        </div>
        <div>
          <button onClick={handleSave} className="btn_submitclr_for icon_mrg_rt">Reset</button>
          <button onClick={closePopup} className="btn_cancelClr_for icon_mrg_rt">Clear</button>
          <button onClick={backPopup} className="btn_submitclr_for">Back</button>
        </div>

      </div>
    </div>
  )
}

export default ForgetPassword;